import { AnaDialogRef } from '@anacapri/angular/dialog';
import { Component, OnInit, Signal } from '@angular/core';

import { IdleTrackingService } from '../idle-tracking.service';

/**
 * Component for the content of the session expiring dialog to warn the user that their session is expiring soon.
 *
 * @author Jesse Bloomster e020902
 */
@Component({
	selector: 'claim-tracker-session-expiring-dialog',
	templateUrl: './session-expiring-dialog.component.html',
	standalone: true
})
export class SessionExpiringDialogComponent implements OnInit {
	idleSecondsRemainingSig: Signal<number>;

	/**
	 * @param idleTrackingService the idle tracking service
	 * @param dialogRef the dialog reference
	 */
	constructor(
		private dialogRef: AnaDialogRef<SessionExpiringDialogComponent>,
		private idleTrackingService: IdleTrackingService
	) {}

	/**
	 * Called when the component is initialized.
	 */
	ngOnInit() {
		this.idleSecondsRemainingSig = this.idleTrackingService.idleSecondsRemainingSig;
	}

	/**
	 * Extend the session by closing the dialog.
	 */
	extendSession() {
		this.dialogRef.close();
	}
}
